import { createContext, useContext, type ReactNode } from "react";

export const BREAKEVEN_ROAS_COLOR = "#595C08";

type BreakevenRoasContextValue = {
  enabled: boolean;
  ratio: number;
};

const BreakevenRoasContext = createContext<BreakevenRoasContextValue>({
  enabled: false,
  ratio: 0,
});

export function BreakevenRoasProvider({
  enabled,
  ratio,
  children,
}: BreakevenRoasContextValue & { children: ReactNode }) {
  return (
    <BreakevenRoasContext.Provider value={{ enabled, ratio }}>
      {children}
    </BreakevenRoasContext.Provider>
  );
}

export function useBreakevenRoas(): BreakevenRoasContextValue {
  return useContext(BreakevenRoasContext);
}
